export const stripIconSasToken = (url: string | null | undefined): string | null => {
  if (!url) return null
  const queryStart = url.indexOf('?')
  return queryStart === -1 ? url : url.slice(0, queryStart)
}

export const buildIconFormData = (file: File): FormData => {
  const formData = new FormData()
  formData.append('icon', file)
  return formData
}
